DO.Subscribe(['app:ready'], () => {
  const elements = document.querySelectorAll('.element-list .element');
  const items = document.querySelectorAll('.element-list-items .element-list-item');

  items.forEach((item) => {
    document.querySelector('.element-list-items').appendChild(item);
  });

  elements.forEach((element) => {
    element.remove();
  });
});
